import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Combobox from '../Helper/Combobox';
import ControlledGrid from '../Helper/ControlledGrid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Contact from './Contact';
import ContactsEnvironnement from './ContactsEnvironnement';

/**
* Class Client
* Client view component
**/
class Client extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Client";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="clientForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire du client.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idClient" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idClient")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Raison sociale/Nom</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="numeroTiers">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Numéro de tiers</ControlLabel></Col>
            <Col sm={2}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("numeroTiers")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="adresse">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Adresse</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("adresse")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="codePostal">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Code postal</ControlLabel></Col>
            <Col sm={2}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("codePostal")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="ville">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Ville</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("ville")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Contact ManyToMany */}
          <PermissionCheck component={Contact.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="contacts">
            <Col componentClass={ControlLabel} sm={2}>Contacts</Col>
            <Col sm={6}>
              <ControlledGrid ref="contactsGrid" path="contactsEnvironnement" objectPath={"clients_contacts/" + this.getObjectProperty("idClient") + "/contacts"} objectClass={ContactsEnvironnement}
              mode={this.state.mode} cbxUrl={REST_API_URL + "clients_contacts/" + this.getObjectProperty("idClient") + "/contacts/inverse/"}
              optionValueKey="idContact" optionLabelKey="fullName" onlyDelete={false} afterAdd={this.refreshContactPrincipal.bind(this)} parentModal={this.props.modal} />
            </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Contact ManyToOne */}
          <FormGroup controlId="idContact">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Contact principal</ControlLabel></Col>
            <Col sm={6}><Combobox url={REST_API_URL + "clients_contacts/" + this.getObjectProperty("idClient") + "/contacts"} optionValueKey="idContact" optionLabelKey="fullName" searchable={true} ref="cbxContactPrincipal"
              default={this.getObjectProperty("idContact")} onChange={this.handleContactPrincipalSelect.bind(this)} placeholder="Contact principal" disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}

  /**
  * refreshContactPrincipal
  * Refresh the contactPrincipal cbx after Contact Add
  **/
  refreshContactPrincipal(obj) {
    this.refs.cbxContactPrincipal.loadData();
  }

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idClient";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let clientObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.contactsGrid !== undefined) clientObj.contacts = this.refs.contactsGrid.getArrayToSave();
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(clientObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        this.setState({
          status: {
            type: 'success',
            message: 'Client sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Client créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/clients/" + newObj.idClient + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.contactsGrid !== undefined) this.refs.contactsGrid.saveAll();
  }

  /**
  * handleContactPrincipalSelect
  * Handle contact principal onChange event
  **/
  handleContactPrincipalSelect(contact) {
    let objState = this.state;
    objState.object["idContact"] = (contact) ? contact.idContact : null;
    this.setState(objState);
  }

}
export default Client;



// WEBPACK FOOTER //
// ./src/views/Entity/Client.js